import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import axiosRetry from 'axios-retry';

axiosRetry(axios, { retries: 3 });

export default axios.create({
    baseURL: window.origin,
    withCredentials: true
})